"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Container = _styledComponents["default"].div.withConfig({
  displayName: "progressbar__Container",
  componentId: "sc-1nh3jy8-0"
})([""]);

var Bar = _styledComponents["default"].div.withConfig({
  displayName: "progressbar__Bar",
  componentId: "sc-1nh3jy8-1"
})(["width:100%;height:16px;border-radius:8px;overflow:hidden;background-color:#f7f7f7;"]);

var Fill = _styledComponents["default"].div.withConfig({
  displayName: "progressbar__Fill",
  componentId: "sc-1nh3jy8-2"
})(["height:100%;background-color:#b3b3b3;border-radius:8px;transition:width:0.3s ease;width:", ";"], function (props) {
  return props.progress ? "".concat(props.progress, "%") : "1%";
});

var Description = _styledComponents["default"].div.withConfig({
  displayName: "progressbar__Description",
  componentId: "sc-1nh3jy8-3"
})(["text-align:center;margin-top:20px;"]);

var Text = _styledComponents["default"].div.withConfig({
  displayName: "progressbar__Text",
  componentId: "sc-1nh3jy8-4"
})(["margin:0;font-size:85%;"]);

var Progress = function Progress(_ref) {
  var prog = _ref.progress,
      enrollment_time = _ref.enrollment_time,
      label = _ref.label;
  var progress = prog;

  if (prog >= 101) {
    progress = 100;
  } else if (prog <= 0) {
    progress = 1;
  }

  return /*#__PURE__*/_react["default"].createElement(Container, null, progress && /*#__PURE__*/_react["default"].createElement(Bar, null, /*#__PURE__*/_react["default"].createElement(Fill, {
    progress: progress
  })), /*#__PURE__*/_react["default"].createElement(Description, null, label !== "" && progress && /*#__PURE__*/_react["default"].createElement(Text, null, /*#__PURE__*/_react["default"].createElement("span", {
    id: "t-progressValue"
  }, Math.round(progress), "%"), label), enrollment_time !== "" && enrollment_time !== -1 && /*#__PURE__*/_react["default"].createElement(Text, null, "On average, it takes about ", enrollment_time, ' ', enrollment_time === '1' || enrollment_time === 1 ? 'minute' : 'minutes', ' ', "to complete.")));
};

Progress.defaultProps = {
  label: " of the sign-up process has been completed.",
  progress: undefined,
  enrollment_time: -1
};
Progress.propsTypes = {
  progress: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  enrollment_time: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
};
var _default = Progress;
exports["default"] = _default;